<style lang="less" scoped>
    .main {
        padding: .3rem 0;
        text-align: center;
        /* background: #f00; */
    }

    .main__body {
        position: relative;
        top: 0;
        left: 0;
        margin:0 auto;
        width: 7.14rem;
        height: 7.14rem;
        /* background: url("../../../assets/img/reality/index_banner.png") no-repeat 50% 50%; */
        background: url("../../../assets/img/reality/bannerkuang.png") no-repeat 50% 50%;
        background-size: cover;
    }

    .main__foot {
        height: 1.5rem;
    }

    .main__title {
        z-index: 9;
    }

    .main__banner {
        position: absolute;
        top: 1.25rem;
        left: 0;
        right: 0;
        z-index: 1;
        /* width: 7.08rem; */
        margin: 0 auto;
        /* background: #98661D; */
        text-align: center;
    }
    .main__banner img {
        width: 6.98rem;
        height: 5.76rem;
        /* visibility: hidden; */
    }

    .main__btns {
        position: absolute;
        bottom: -1rem;
        left: 0;
        right: 0;
        z-index: 2;
    }

    .btn-main {
        position: relative;
        top: 0;
        left: 0;
        display: block;
        width: 2.66rem;
        height: 2.16rem;
        margin: 0 auto;
        background: url("../../../assets/img/reality/btn_juesai_round_org.png") no-repeat 0 0;
        background-size: 100% auto;
    }

    .btn-main.disabled {
        background-image: url("../../../assets/img/reality/btn_juesai_round_gray.png");
    }

    .btn-main__desc {
        position: absolute;
        top: 1.3rem;
        left: 0;
        width: 100%;
        text-align: center;
        color: #ff0;
        line-height: .32rem;
        z-index: 3;
    }

    .disabled .btn-main__desc {
        color: #ccc;
    }

    .btn-sub {
        width: 1.56rem;
        height: 1.62rem;
        line-height: 1.62rem;
        position: relative;
        display: block;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
        text-align: center;
        position: absolute;
        top: .3rem;
    }

    .btn-sub span {
        visibility: hidden;
    }

    .btn-sub--lt {
        left: 0.6rem;
        background-image: url("../../../assets/img/reality/btn_huodongshouye.png");
    }

    .btn-sub--rt {
        right: 0.6rem;
        background-image: url("../../../assets/img/reality/btn_juesaijilu.png");
    }

</style>
<template>
    <div class="main">
        <div class="main__body">
            <div class="main__title"><img src="../../../assets/img/reality/btn_juesai.png" alt=""></div>
            <div class="main__banner">
                <a href="/"><img src="../../../assets/img/reality/bisai-banner.png" alt=""></a>
            </div>
            <div class="main__btns">
                <router-link class="btn-sub btn-sub--lt" tag="a" to="/"><span>活动首页</span></router-link>
                <router-link class="btn-sub btn-sub--rt" tag="a" to="/reality/games"><span>做题记录</span></router-link>
                <a class="btn-main" :class="{disabled: !canPlay}" @click="play">
                    <span class="btn-main__desc" v-if="canPlay">({{playedCount}}/{{allCount}})</span>
                    <span class="btn-main__desc" v-else>{{error}}</span>
                </a>
            </div>
        </div>
        <div class="main__foot">

        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: "index-main",
        computed: {
            ...mapGetters(['realityCupId', 'isAdvance', 'isBefore', 'isAfter', 'finalEnd', 'finalBegin']),
            ...mapGetters('reality', ['gameId', 'kid', 'isFinished', 'curGameId', 'curKid', 'playedCount', 'allCount']),
            canPlay() {
                const {
                    error
                } = this
                return !error
                // const {
                //     allCount,
                //     playedCount,
                //     isAdvance
                // } = this
                // // return isAdvance && allCount > 0 && playedCount < allCount
                // return allCount > 0 && playedCount < allCount
            },
            error() {
                const {
                    allCount,
                    isFinished,
                    isAfter,
                    isBefore,
                    isAdvance,
                    finalBegin,
                    finalEnd
                } = this
                if (isAfter(finalEnd)) {
                    return '决赛已结束'
                } else if (isBefore(finalBegin)) {
                    return '决赛未开始'
                } else if(!isAdvance) {
                    return '未晋级决赛'
                } else if(isFinished) {
                    return '已完成决赛'
                } else if (!allCount) {
                    return '暂无比赛题目'
                }
                return ''
            }
        },
        methods: {
            ...mapActions(['loadRealityCupId']),
            ...mapActions('reality', ['loadPlay']),
            play() {
                const {
                    canPlay
                } = this;
                if (!canPlay) {
                    this.$toast(this.error)
                } else {
                    const {
                        realityCupId,
                        curGameId,
                        curKid
                    } = this;
                    // alert(JSON.stringify({cupId: `${realityCupId}`, gameId}))
                    // const realityCupId = this.realityCupId
                    // alert(cupId)
                    if (canPlay) {
                        this.$router.push({
                            name: 'play',
                            params: {
                                cupId: realityCupId,
                                gameId: curGameId,
                                kid: curKid
                            }
                        })
                    // } else {

                    }
                }

            },
            async start() {
                // this.play(this.realityCupId)
            }
        },
        async created() {
            if (!this.realityCupId) {
                await this.loadRealityCupId()
            }
            await this.loadPlay({
                cupId: this.realityCupId
            })
        }
    };

</script>
